 
    import MatriculaService from   "@/service/v1/sigap/MatriculaService"  
    import { Options, Vue } from "vue-class-component"; 
    import CardRh from   "@/components/cards/ManzaCard.vue"  
    import {  Prop  , Watch } from 'vue-property-decorator';  
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "HistoricoIndex",
        components: {  CardRh   },
    }) 
    export default class HistoricoIndex extends Vue {
        
        @Prop( ) readonly matricula!: any  
          
        @authStore.Getter
		public token!: any 
        
        public service = new MatriculaService();
         
        public url: any = "";
         
        created(){ 
            this.url = this.service.getApiUrl() + '/' + this.matricula.id + '/historico/pdf' + '?token=' + this.token ;  
        } 
   
    } 
  
